// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__uksdi","ani":"menu_ani__7ju5E","active":"menu_active__pS7yB","submenu":"menu_submenu__ous8u"};